document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('copyright').textContent = `${new Date().getFullYear()}`;
});